import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getBlobFiles } from '../utils/urls';

import { TemplateResult as BlobDirectory } from 'types/procedureBuilder';
import { ErrorModal } from 'types/modalTypes';

async function fetchBlobFiles({
  accountId,
  uniqueId,
}: TVariables): Promise<TResult | undefined> {
  const response = await fetch(getBlobFiles(accountId, uniqueId), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: Array<BlobDirectory> | undefined;
  IsSucess: boolean;
  StatusCode: number;
};

type TVariables = {
  accountId: number;
  uniqueId: string | undefined;
};

function useGetBlobFiles({
  accountId,
  uniqueId,
}: TVariables): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_file_tree', accountId, uniqueId],
    async () => {
      const files = await fetchBlobFiles({
        accountId,
        uniqueId,
      });
      return files;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
      enabled: uniqueId !== undefined,
    },
  );
}

export { useGetBlobFiles };
